/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export const colorStyleguideStyle = {
  paper: {
    padding: "1rem",
    height: "100%",
  },
};
